var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecordingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none",
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#880CE8",
    d: "M9.172 1H5c-1.886 0-2.828 0-3.414.586C1 2.172 1 3.114 1 5v10c0 1.886 0 2.828.586 3.414C2.172 19 3.114 19 5 19h6c1.886 0 2.828 0 3.414-.586C15 17.828 15 16.886 15 15V6.828c0-.408 0-.613-.076-.796-.076-.184-.22-.329-.51-.618l-3.828-3.828c-.29-.29-.434-.434-.618-.51C9.785 1 9.58 1 9.172 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#880CE8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.855 12.08-3.182-1.363A1.2 1.2 0 0 0 5 11.82v2.36a1.2 1.2 0 0 0 1.673 1.103l3.182-1.364c.808-.346.808-1.492 0-1.838Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#880CE8",
    d: "M9 1v4c0 .943 0 1.414.293 1.707C9.586 7 10.057 7 11 7h4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordingIcon);
export default __webpack_public_path__ + "static/media/recording_icon.2ae1de3bf33145e0b0119abc97c52944.svg";
export { ForwardRef as ReactComponent };